//  const baseURL = "http://localhost:2030/api/v1";
const baseURL = "https://e-commerce-api-zc88.onrender.com/api/v1";
export default baseURL;
